import type { Step } from "react-joyride";

export const districtsTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການເມືອງ. ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການເມືອງ ເປີດ/ປິດການສະແດງໃນ dropdown ໄດ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="geo-districts-toolbar"]',
    content: "ປຸ່ມສ້າງເມືອງໃໝ່. ກົດເພື່ອເພີ່ມເມືອງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-districts-filter"]',
    content:
      "ກອງຂໍ້ມູນ: ຄົ້ນຫາຊື່, ແຂວງ, ສະຖານະເປີດ/ປິດ. ກົດ 'ລ້າງຕົວກອງ' ເພື່ອລຶບການກອງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="geo-districts-table"]',
    content: "ຕາຕະລາງເມືອງ. ສາມາດແກ້ໄຂ ຫຼື ເປີດ/ປິດການສະແດງໄດ້ຈາກປຸ່ມການກະທໍາ.",
    placement: "top",
  },
];
